import { Routes } from '@angular/router';
import { cockpitRoutes } from './pages/cockpit/routes';
import { componentLabRoutes } from './pages/component-lab/routes';
import { HomePage } from './pages/home-page';
import { leercabineRoutes } from './pages/leercabine/routes';
import { mechanicRoutes } from './pages/mechanics/routes';

export const routes: Routes = [
  {
    path: '',
    component: HomePage,
  },
  {
    path: 'component-lab',
    children: componentLabRoutes,
  },
  {
    path: 'leercabine',
    children: leercabineRoutes,
  },
  {
    path: 'cockpit',
    children: cockpitRoutes,
  },
  {
    path: 'mechanics',
    children: mechanicRoutes,
  },
];
